import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import { publicHttpClient } from '@/lib/httpClient';

import type { LatLng } from '../place/types';
import type { DefaultQueryError } from '../types';
import type { ServiceModalData } from './types';

export const getServiceModelDetailFn = async (
  id: string,
  params: LatLng | null
) => {
  const response = await publicHttpClient.get<ServiceModalData>(
    apiRoutes.services.detail(id),
    {
      params,
    }
  );
  return response.data;
};

export const useGetServiceModelDetail = (
  id: string,
  params: LatLng | null,
  opts?: UseQueryOptions<ServiceModalData, DefaultQueryError>
) =>
  useQuery<ServiceModalData, DefaultQueryError>(
    [apiRoutes.services.detail(id), params],
    () => getServiceModelDetailFn(id, params),
    opts
  );
